import SVG from "react-inlinesvg";
import oocaLogo from "@/assets/svg/ooca_logo-default-side.svg";
import "@/components/loading/fullLoader.scss";
import { Row } from "react-bootstrap";

const FullScreenloading = () => {
  return (
    <>
      <div>
        <div className="fullscreen-loading m-auto">
          <div className="background"></div>
          <Row className="mt-5">
            <SVG src={oocaLogo} />
          </Row>
          <div className="container-card">
            <h1 className="text-blue-1 sr-only my-3">Loading...</h1>
            <div className="text-body1"></div>
            <div className="lds-spinner mt-2">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FullScreenloading;
